import MappingModule from "./MappingModule";
import { ModalLayout } from "../modal/ModalLayout";
import PropTypes from "prop-types";
import React from "react";
import Dispatcher from "Dispatcher";
import MappingActions from "data/MappingActions";
import TableStore from "data/TableStore";
import MapDialogActions from "data/MapDialogActions";
import SuperRecordActions from "data/SuperRecordActions";

class MappingModalModule extends React.Component {

    constructor(props) {
        super(props);
        this.onImport = this.onImport.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }

    componentDidMount() {
        this.closeToken = Dispatcher.register(action => {
            if (action.type !== SuperRecordActions.CANCEL_FOR_OPTLOCK) return;
            this.onClose();
        });
    }

    componentWillUnmount() {
        if (this.closeToken != null) {
            Dispatcher.unregister(this.closeToken);
            delete this.closeToken;
        }
        if (this.importToken != null) {
            Dispatcher.unregister(this.importToken);
            delete this.importToken;
        }
    }

    onClose() {
        const {
            view,
        } = this.props;
        view && view.close();
    }

    onImport() {
        if (this.importToken != null) {
            console.warn("import requested while one is already going?");
            return;
        }
        Dispatcher.dispatch({
            type: MapDialogActions.IMPORT,
        });
        this.importToken = Dispatcher.register(action => {
            if (action.type !== MappingActions.IT_IS_DONE) return;
            Dispatcher.waitFor([
                TableStore.getDispatchToken(),
            ]);
            this.onClose();
        });
    }

    onCancel() {
        Dispatcher.dispatch({
            type: MapDialogActions.CANCEL,
        });
        this.onClose();
    }

    render() {
        const {
            fluxContext,
        } = this.props;

        const modalOptions = {
            title: "Record Mapping",
            size: "modal-xlg"
        };

        return (
            <ModalLayout
                modalOptions={modalOptions}
                triggerClose={this.onCancel}
                resizeBodyOnRender
            >
                <MappingModule
                    fluxContext={fluxContext}
                    onImport={this.onImport}
                    onCancel={this.onCancel}
                />
            </ModalLayout>
        );
    }
}

MappingModalModule.propTypes = {
    fluxContext: PropTypes.string.isRequired,
    view: PropTypes.instanceOf(Backbone.Marionette.View),
};

export default MappingModalModule;



// WEBPACK FOOTER //
// ./app/lib/mapping/MappingModalModule.js